// extracted by mini-css-extract-plugin
export default {"headerSpacing":"TMS_headerSpacing__f65co","TMSheader":"TMS_TMSheader__v3N7z","TMSTable":"TMS_TMSTable__+SesT"};